import { Input, Label } from '@iwoca/orion';
import { useLingui } from '@lingui/react/macro';
import { useFormContext } from 'react-hook-form';

import styles from './NameScreen.module.css';
import { nameSchema } from './NameScreen.schema';
import { TMobileSignupForm, TPersonTitleDE } from '../../form/form';
import { useStageFieldTracking } from '../../form/MobileSignupFieldTracking';
import { useScreenValidation } from '../../form/validation/useScreenValidation';
import { OptionCards, TOption } from '../../OptionCards/OptionCards';
import { StepLayout } from '../../StepLayout/StepLayout';

// DIT-686. Salutation + first / last name. Reads/writes the shared mobile
// signup form store (DIT-664).
export const NameScreen = () => {
  const { t } = useLingui();
  const {
    register,
    watch,
    setValue,
    formState: { errors },
  } = useFormContext<TMobileSignupForm>();
  const { validateAndContinue } = useScreenValidation(nameSchema);
  const { fieldProps } = useStageFieldTracking();

  const title = watch('title');

  const titles: TOption<TPersonTitleDE>[] = [
    { value: 'herr', label: t`Man` },
    { value: 'frau', label: t`Woman` },
  ];

  return (
    <StepLayout
      stageTitle={t`Tell us about yourself`}
      heading={t`What is your name?`}
      onContinue={validateAndContinue}
      fieldProps={fieldProps}
    >
      <div className={styles.fields}>
        <div className={styles.field}>
          <Label>{t`Title`}</Label>
          <OptionCards
            name="title"
            options={titles}
            value={title}
            onChange={(value) =>
              setValue('title', value, { shouldDirty: true })
            }
            columns={2}
            hideRadio
          />
        </div>
        <Input
          {...register('firstName')}
          label={t`First name`}
          className="fs-mask"
          error={errors.firstName?.message}
        />
        <Input
          {...register('lastName')}
          label={t`Last name`}
          className="fs-mask"
          error={errors.lastName?.message}
        />
      </div>
    </StepLayout>
  );
};
